"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconOrderCanceledStep = void 0;
var React = __importStar(require("react"));
var IconOrderCanceledStep = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#464650", d: "M13,11 L11,11 L11,8.5 L11.889,5 L12.109,5 L13,8.562 L13,11 Z M7.601,5.2 C7.694,5.075 7.844,5 8,5 L10.857,5 L10.095,8 L5.5,8 L7.601,5.2 Z M16.329,5.276 C16.344,5.307 16.363,5.336 16.384,5.362 L18.468,8 L13.89,8 L13.14,5 L15.882,5 C16.073,5 16.244,5.105 16.329,5.276 L16.329,5.276 Z M19.892,8.19 L17.197,4.779 C16.934,4.297 16.435,4 15.882,4 L12.5,4 L11.5,4 L8,4 C7.53,4 7.081,4.225 6.8,4.601 L4.1,8.2 C4.035,8.286 4,8.392 4,8.5 L4,9.5 L4,18.5 C4,19.327 4.673,20 5.5,20 L18.5,20 C19.327,20 20,19.327 20,18.5 L20,17.5 C20,17.224 19.776,17 19.5,17 C19.224,17 19,17.224 19,17.5 L19,18.5 C19,18.775 18.776,19 18.5,19 L5.5,19 C5.224,19 5,18.775 5,18.5 L5,9.5 C5,9.225 5.224,9 5.5,9 L10,9 L10,11.5 C10,11.776 10.224,12 10.5,12 L13.5,12 C13.776,12 14,11.776 14,11.5 L14,9 L18.5,9 C18.776,9 19,9.225 19,9.5 L19,10.5 C19,10.776 19.224,11 19.5,11 C19.776,11 20,10.776 20,10.5 L20,9.5 L20,8.5 C20,8.388 19.962,8.278 19.892,8.19 L19.892,8.19 Z" }),
        React.createElement("path", { fill: "red", d: "M20.207,14 L21.853,12.354 C22.049,12.158 22.049,11.842 21.853,11.646 C21.658,11.451 21.342,11.451 21.146,11.646 L19.5,13.293 L17.853,11.646 C17.658,11.451 17.342,11.451 17.146,11.646 C16.951,11.842 16.951,12.158 17.146,12.354 L18.793,14 L17.146,15.646 C16.951,15.842 16.951,16.158 17.146,16.354 C17.244,16.451 17.372,16.5 17.5,16.5 C17.628,16.5 17.756,16.451 17.853,16.354 L19.5,14.707 L21.146,16.354 C21.244,16.451 21.372,16.5 21.5,16.5 C21.628,16.5 21.756,16.451 21.853,16.354 C22.049,16.158 22.049,15.842 21.853,15.646 L20.207,14 Z" })))); };
exports.IconOrderCanceledStep = IconOrderCanceledStep;
exports.IconOrderCanceledStep.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconOrderCanceledStep;
